import React from 'react';
import get from 'lodash/get';

import AudienceSelector from '../../shared/AudienceSelector';
import Dropdown from 'src/presentation/components/forms/Dropdown';
import QuickActionConfiguration from '../components/QuickActionConfiguration';
import QuickActions from 'src/images/QuickActions.svg';
import answerLanguagesResource from 'src/actions/answers/answerLanguagesResource';
import audiencesResource from 'src/actions/audiences/audiencesResource';
import useAudienceOptions from 'src/presentation/components/pages/shared/hooks/useAudienceOptions';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import useLanguageOptions from 'src/presentation/components/pages/ivr/hooks/useLanguageOptions';
import useResource from 'src/presentation/hooks/useResource';
import { CHAT_WIDGET_TYPE, FIELDS_MAPPER, QUICK_ACTIONS_DESCRIPTION } from '../chatConstants';
import { HalfRow, QuickActionsStyledImage, SelectorContainer } from 'src/presentation/components/pages/chat/ChatLayout';
import { Section } from 'src/presentation/components/forms/Layout';
import { CHAT_BRAND } from 'src/constants/branding';

export default function ChatQuickActions({ configuration }) {
  const { value: languages } = useDocumentResource(answerLanguagesResource);
  const languageOptions = useLanguageOptions(languages);

  const audiences = useResource(audiencesResource).values;
  const formattedAudiences = useAudienceOptions(audiences);

  const widgetType = get(configuration, FIELDS_MAPPER.WIDGET_TYPE.path);

  if (widgetType === CHAT_WIDGET_TYPE) {
    return null;
  }

  return (
    <Section header="Quick Actions" description={QUICK_ACTIONS_DESCRIPTION} data-aid="quick-actions-section">
      <QuickActionsStyledImage src={QuickActions} />
      {renderLanguageSelector(languageOptions)}

      <HalfRow>
        <SelectorContainer>
          <AudienceSelector
            attr={FIELDS_MAPPER.AUDIENCE.path}
            audienceOptions={formattedAudiences}
            description={FIELDS_MAPPER.AUDIENCE.description}
            section={CHAT_BRAND.name}
          />
        </SelectorContainer>
      </HalfRow>

      <QuickActionConfiguration configuration={configuration} />
    </Section>
  );
}

function renderLanguageSelector(options) {
  return (
    <HalfRow>
      <SelectorContainer>
        <Dropdown
          attr={FIELDS_MAPPER.LANGUAGE.path}
          data-aid={FIELDS_MAPPER.LANGUAGE.path}
          description={FIELDS_MAPPER.LANGUAGE.description}
          label="Language"
          options={options}
        />
      </SelectorContainer>
    </HalfRow>
  );
}
